import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";
import { contains } from "@fluorescent/dom";

const selectors = {
  slide: ".carousel__slide",
};

export default node => {
  if (!shouldAnimate(node)) return;

  let offsetSelectors = [selectors.slide];

  // Last slide wraps and peaks at the start of the list
  // if there are 2 more slides than columns.
  // Start the animation with the last slide
  if (contains(node, "carousel--columns-wrap-around")) {
    offsetSelectors = [
      `${selectors.slide}:last-of-type`,
      `${selectors.slide}:not(:last-of-type)`,
    ];
  }

  delayOffset(node, offsetSelectors);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
